import * as formActions from 'libs/rx-state/actions';

import { Actions, ofType } from '@ngrx/effects';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { filter, map, pluck, skip, takeUntil, tap } from 'rxjs/operators';

import { FormTemplate } from '@nrwl/rx-models';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@nrwl/environment';

@Injectable({
  providedIn: 'root',
})
export class FormTemplateFilesService {
  public type: string;
  template: any;

  constructor(
    private http: HttpClient,
    private store: Store<any>,
  ) {
    this.store.pipe(pluck('forms-manager', 'template', 'selectedForm')).subscribe((res: any) => {
      if (res) {
        this.template = res;
      }
    });
  }

  init() {}

  public uploadFile(event, type) {
    this.type = type;
    if (event.target.files && event.target.files.length > 0) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        this.setupReader(files[i]);
      }
    }
  }

  public setupReader(file) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e: any) => {
      const b64Content = e.target.result;
      const block = b64Content.split(';');
      const contentType = block[0].split(':')[1] || '';
      const b64Data = block[1].split(',')[1];
      this.createFiles(b64Data);
    };
  }

  public createFiles(b64Data: string) {
    if (this.template.id > 0) {
      const formData = new FormData();
      formData.append('content', b64Data);
      formData.append('type', this.type);
      formData.append('template', String(this.template.id));
      this.http
        .post(`${environment.baseAPIUrl}formtemplatefiles/`, formData)
        .subscribe((result) => {
          this.getTemplate();
        });
    }
  }

  public deleteFile(fileId: number): any {
    return this.http.delete(environment.baseAPIUrl + `formtemplatefiles/${fileId}/`);
  }

  getTemplate() {
    this.store.dispatch(new formActions.LoadSelectedTemplate(this.template.id));
  }
}
